// ===== Countdown timer (flash sale) =====
// Counts down to a rolling deadline 5 days, 9 hours out from first visit,
// stored in localStorage so it persists between page loads.
(function () {
  var cdEl = document.getElementById('countdown');
  var cdD = parseInt((cdEl && cdEl.dataset.days) || '3', 10);
  var cdH = parseInt((cdEl && cdEl.dataset.hours) || '9', 10);
  var KEY = 'ddc_sale_deadline_' + cdD + '_' + cdH;
  var deadline = localStorage.getItem(KEY);
  if (!deadline || Number(deadline) < Date.now()) {
    deadline = Date.now() + (cdD * 24 * 60 * 60 + cdH * 60 * 60) * 1000;
    localStorage.setItem(KEY, deadline);
  }
  deadline = Number(deadline);

  var els = {
    d: document.getElementById('cd-days'),
    h: document.getElementById('cd-hours'),
    m: document.getElementById('cd-min'),
    s: document.getElementById('cd-sec')
  };
  if (!els.d || !els.h || !els.m || !els.s) return;

  function tick() {
    var diff = Math.max(0, deadline - Date.now());
    var sec = Math.floor(diff / 1000);
    els.d.textContent = Math.floor(sec / 86400);
    els.h.textContent = Math.floor((sec % 86400) / 3600);
    els.m.textContent = Math.floor((sec % 3600) / 60);
    els.s.textContent = sec % 60;
  }
  tick();
  window.ddEverySecond = window.ddEverySecond || [];
  window.ddEverySecond.push(tick);
})();

// ===== Buy box scarcity: offer countdown, ship cutoff, stock bar =====
(function () {
  // Offer countdown — synced to the same deadline as the announcement bar
  var cdEl2 = document.getElementById('countdown');
  var key2 = 'ddc_sale_deadline_' + parseInt((cdEl2 && cdEl2.dataset.days) || '3', 10) + '_' + parseInt((cdEl2 && cdEl2.dataset.hours) || '9', 10);
  var deadline = Number(localStorage.getItem(key2));
  var ouD = document.getElementById('ou-days'),
      ouH = document.getElementById('ou-hours'),
      ouM = document.getElementById('ou-min'),
      ouS = document.getElementById('ou-sec');

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function tickOffer() {
    if (!ouD) return;
    var sec = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
    ouD.textContent = Math.floor(sec / 86400);
    ouH.textContent = pad(Math.floor((sec % 86400) / 3600));
    ouM.textContent = pad(Math.floor((sec % 3600) / 60));
    ouS.textContent = pad(sec % 60);
  }
  if (ouD) {
    tickOffer();
    window.ddEverySecond = window.ddEverySecond || [];
    window.ddEverySecond.push(tickOffer);
  }

  // Ship cutoff — orders before 18:00 local time ship same day
  var shipDateEl = document.getElementById('shipDate');
  var shipTimerEl = document.getElementById('shipTimer');
  var months = ['January','February','March','April','May','June',
                'July','August','September','October','November','December'];

  function tickShip() {
    if (!shipDateEl || !shipTimerEl) return;
    var now = new Date();
    var cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 18, 0, 0);
    var shipDay = new Date(now);
    if (now >= cutoff) {            // past cutoff: next dispatch is tomorrow 18:00
      shipDay.setDate(shipDay.getDate() + 1);
      cutoff.setDate(cutoff.getDate() + 1);
      shipDateEl.parentNode.firstChild.textContent = 'Ships tomorrow, ';
    }
    shipDateEl.textContent = months[shipDay.getMonth()] + ' ' + shipDay.getDate();
    var mins = Math.max(0, Math.floor((cutoff - now) / 60000));
    shipTimerEl.textContent = Math.floor(mins / 60) + 'h ' + (mins % 60) + 'm';
  }
  tickShip();
  setInterval(tickShip, 30000);

  // Stock bar — counts down slowly per visit, floors at 6 so it stays plausible
  var KEY = 'ddc_stock_count';
  var stock = Number(localStorage.getItem(KEY));
  if (!stock || stock < 6 || stock > 14) stock = 14;
  var countEl = document.getElementById('stockCount');
  var fillEl = document.getElementById('stockFill');
  if (countEl && fillEl) {
    countEl.textContent = stock;
    fillEl.style.width = Math.round((stock / 80) * 100) + '%';
    // one pouch "sells" 25–60s after page load, down to the floor
    if (stock > 6) {
      setTimeout(function () {
        stock -= 1;
        localStorage.setItem(KEY, stock);
        countEl.textContent = stock;
        fillEl.style.width = Math.round((stock / 80) * 100) + '%';
      }, 25000 + Math.random() * 35000);
    }
  }
})();

// ===== Testimonial carousel =====
(function () {
  var slides = document.querySelectorAll('#testimonialCarousel .t-slide');
  var dotsWrap = document.getElementById('carouselDots');
  if (!slides.length || !dotsWrap) return;
  // the gold-overrides stylesheet freezes this carousel into a static grid —
  // don't burn cycles auto-advancing slides nobody can see moving
  var isStatic = !!document.getElementById('dd-gold-overrides');
  var current = 0;
  var timer;

  slides.forEach(function (_, i) {
    var b = document.createElement('button');
    b.setAttribute('aria-label', 'Review ' + (i + 1));
    if (i === 0) b.classList.add('active');
    b.addEventListener('click', function () { show(i); restart(); });
    dotsWrap.appendChild(b);
  });
  var dots = dotsWrap.querySelectorAll('button');

  function show(i) {
    slides[current].classList.remove('active');
    dots[current].classList.remove('active');
    current = i;
    slides[current].classList.add('active');
    dots[current].classList.add('active');
  }
  function next() { show((current + 1) % slides.length); }
  function restart() {
    if (isStatic) return;
    clearInterval(timer);
    timer = setInterval(next, 5000);
  }
  restart();
})();

// ===== Hero review slider =====
(function () {
  var slides = document.querySelectorAll('#heroReviews .hr-slide');
  var dotsWrap = document.getElementById('heroDots');
  if (!slides.length || !dotsWrap) return;
  var isStatic = !!document.getElementById('dd-gold-overrides');
  var current = 0;
  var timer;

  slides.forEach(function (_, i) {
    var b = document.createElement('button');
    b.setAttribute('aria-label', 'Hero review ' + (i + 1));
    if (i === 0) b.classList.add('active');
    b.addEventListener('click', function () { show(i); restart(); });
    dotsWrap.appendChild(b);
  });
  var dots = dotsWrap.querySelectorAll('button');

  function show(i) {
    slides[current].classList.remove('active');
    dots[current].classList.remove('active');
    current = i;
    slides[current].classList.add('active');
    dots[current].classList.add('active');
  }
  function next() { show((current + 1) % slides.length); }
  function restart() {
    if (isStatic) return;
    clearInterval(timer);
    timer = setInterval(next, 4500);
  }
  restart();
})();

// ===== Quantity selectors =====
document.querySelectorAll('.qty-row').forEach(function (row) {
  var input = row.querySelector('.qty-input');
  row.querySelectorAll('.qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      if (btn.dataset.action === 'inc') v += 1;
      else v = Math.max(1, v - 1);
      input.value = v;
    });
  });
});

// ===== Sticky CTA — show after scrolling past the hero =====
(function () {
  var cta = document.getElementById('stickyCta');
  var hero = document.querySelector('.hero');
  if (!cta || !hero) return;
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      cta.classList.toggle('visible', !e.isIntersecting && e.boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(hero);
  } else {
    window.addEventListener('scroll', function () {
      cta.classList.toggle('visible', window.scrollY > hero.offsetTop + hero.offsetHeight);
    }, { passive: true });
  }
})();

// ===== Slide-in menu drawer (left side) =====
(function () {
  var burger = document.getElementById('hamburger');
  var nav = document.getElementById('mainNav');
  var overlay = document.getElementById('navOverlay');
  var closeBtn = document.getElementById('navClose');
  if (!burger || !nav) return;

  function setMenu(open) {
    nav.classList.toggle('open', open);
    if (overlay) overlay.classList.toggle('show', open);
  }

  burger.addEventListener('click', function () {
    setMenu(!nav.classList.contains('open'));
  });
  if (closeBtn) closeBtn.addEventListener('click', function () { setMenu(false); });
  if (overlay) overlay.addEventListener('click', function () { setMenu(false); });
  nav.querySelectorAll('a').forEach(function (link) {
    link.addEventListener('click', function () { setMenu(false); });
  });
})();

// ===== FAQ: close other items when one opens =====
document.querySelectorAll('.faq-item').forEach(function (item) {
  item.addEventListener('toggle', function () {
    if (item.open) {
      document.querySelectorAll('.faq-item[open]').forEach(function (other) {
        if (other !== item) other.open = false;
      });
    }
  });
});


// ===== Reviews wall: 50 placeholder reviews, 10 per "Load More" =====
// Placeholder content to demo the design — swap for real reviews later.
(function () {
  var list = document.getElementById('rwList');
  var moreBtn = document.getElementById('rwMore');
  var shownEl = document.getElementById('rwShown');
  if (!list || !moreBtn) return;

  var REVIEWS = [
    [5,'Madison R.','06/10/2026','Picky Yorkie approved','My Yorkie sniffs everything and walks away. These she waits by the cupboard for. Stools went from soft-serve to picture perfect in under a week.'],
    [5,'Sophie L.','06/09/2026','No more cutting chews in half','Finally a dose made for a 6 lb body. The chew is tiny, she thinks it\'s a treat, and I\'m not guessing anymore.'],
    [5,'Jasmine K.','06/08/2026','The paw licking stopped','Three weeks in and the constant paw chewing has calmed right down. Her coat looks shinier too.'],
    [4,'Olivia T.','06/07/2026','Took two weeks but worth it','First week I saw nothing and almost gave up. Week two her tummy settled and the gas is gone. Be patient!'],
    [5,'Hannah P.','06/06/2026','Easy cancel is real','I tested the pause button before subscribing. One click, no emails, no guilt trip. Trust earned, subscription kept.'],
    [5,'Emily W.','06/05/2026','Chihuahua mom here','Bella is 4 lbs of attitude and refuses everything. She devours these. The Devour-It guarantee is what got me to try.'],
    [5,'Grace M.','06/04/2026','Vet was impressed','Showed my vet the strain list at our checkup. She said spore-based blends are exactly what she\'d look for.'],
    [5,'Chloe B.','06/03/2026','Goodbye 5am cleanups','I used to keep paper towels by the bed. Two weeks on these chews and we sleep through the night again.'],
    [4,'Ava S.','06/02/2026','Good, slightly crumbly','Works great and she loves the taste. One star off because a few chews crumbled in the pouch.'],
    [5,'Isabella D.','06/01/2026','My Maltese is obsessed','She spins in circles when I open the pouch. Tummy has been calm for a month straight.'],
    [5,'Mia C.','05/30/2026','Senior Pom doing great','My 12-year-old Pomeranian has had a sensitive gut her whole life. This is the first thing that kept her regular for weeks.'],
    [5,'Amelia F.','05/29/2026','The yeasty smell is gone','That corn-chip paw smell vanished around week three. I didn\'t even know a probiotic could do that.'],
    [5,'Harper J.','05/28/2026','Shihtzu approved','Coco inhales it before I let go. Firm stools since day 4. Subscribed for the lifetime discount.'],
    [5,'Evelyn N.','05/27/2026','After antibiotics lifesaver','Our toy poodle finished a course of antibiotics and her gut was a mess. This got her back on track fast.'],
    [4,'Abigail G.','05/26/2026','Wish the pouch was bigger','No complaints about the product, my girl loves it. Just wish a pouch lasted more than a month with two dogs.'],
    [5,'Ella V.','05/25/2026','No fridge needed = travel win','We RV most of the year. A shelf-stable probiotic that actually works is exactly what we needed.'],
    [5,'Scarlett H.','05/24/2026','Less gas, happier home','You could hear her tummy from across the room. Now? Silence. Blessed silence.'],
    [5,'Aria M.','05/23/2026','My picky diva eats it first','She eats the chew before her actual dinner. If you have a fussy small breed, just try it.'],
    [5,'Layla R.','05/22/2026','Calmer too somehow','Got it for digestion but she honestly seems less anxious on walks. Read about the gut-brain thing on their site.'],
    [5,'Zoe A.','05/21/2026','Real results in 5 days','Day 5 was the first normal poop in months. I took a photo. My husband thinks I\'m insane. Worth it.'],
    [5,'Nora K.','05/20/2026','Frenchie mix mom','Technically she\'s 23 lbs so right at the limit — works perfectly, no half-dosing math.'],
    [5,'Lily T.','05/19/2026','Subscription done right','Skipped a month when we had extra, took 10 seconds online. Why is this so rare?'],
    [4,'Hazel B.','05/18/2026','Solid product','Does what it says. Took closer to three weeks for us, but the soft stool is gone.'],
    [5,'Violet S.','05/17/2026','Coat is glowing','Groomer asked what we changed. Only thing new is this chew. Shiniest coat she\'s ever had.'],
    [5,'Aurora P.','05/16/2026','Yorkie tummy fixed','Years of on-and-off diarrhea, two vet visits a year. Six weeks on this and she\'s a different dog.'],
    [5,'Savannah W.','05/15/2026','Treat-level excitement','She does her happy dance for it. I love that something this healthy reads as a treat to her.'],
    [5,'Audrey L.','05/14/2026','Bought for one, now both','Started with my Chihuahua, now my mom\'s Shih Tzu is on it too. Both thriving.'],
    [5,'Brooklyn M.','05/13/2026','The mystery gift was cute','Came with a little bandana in the 3-month box. My diva wears it to brunch. Obsessed.'],
    [3,'Claire D.','05/12/2026','Still waiting on results','Two weeks in, she eats them happily but stools are only slightly better. Support told me to give it a month — updating later.'],
    [5,'Lucy F.','05/11/2026','No more food guilt','I felt awful watching her struggle after meals. Now she\'s comfortable and I\'m not googling symptoms at midnight.'],
    [5,'Paisley N.','05/10/2026','Works for my teacup','3.8 lbs and even she handles the dose perfectly. This is what small-dog-specific actually means.'],
    [5,'Everly G.','05/09/2026','Accidents stopped','We were down to one accident a week, now zero for three weeks straight. The rug survives.'],
    [5,'Anna J.','05/08/2026','Skeptic converted','I rolled my eyes at "luxury dog probiotic". Then her chronic soft stool cleared in 10 days. I\'m the brand\'s problem now.'],
    [5,'Caroline V.','05/07/2026','Pumpkin + marshmallow root','You can tell the formula was thought through. The botanicals make a difference for her sensitive tummy.'],
    [4,'Genesis H.','05/06/2026','Great but went OOS once','Product is fantastic. Ordering early because the batch sold out on me last month.'],
    [5,'Kennedy A.','05/05/2026','Pomchi approved','My Pomchi is dramatic about everything except these. Gone in two seconds flat.'],
    [5,'Sadie R.','05/04/2026','Firm poops, happy mom','That\'s it. That\'s the review.'],
    [5,'Gabriella K.','05/03/2026','Better than the powder','We tried a powder before — she ate around it somehow. A chew she begs for is just easier.'],
    [5,'Stella T.','05/02/2026','Three months in','Reordering for the third time. Consistent results, zero fuss, and she still acts like it\'s candy.'],
    [5,'Natalie B.','05/01/2026','Itching way down','Her belly was pink from scratching. A month in and the skin looks calm. Vet approved continuing.'],
    [5,'Leah S.','04/30/2026','Dainty chew, big results','The chew really is small — fits her tiny mouth, no choking panic like with the big brand we tried.'],
    [5,'Penelope P.','04/29/2026','Gut stuff is real','Did a lot of reading before buying. The three-strain spore blend is the same type used in actual studies. It shows.'],
    [4,'Riley W.','04/28/2026','Four stars for now','Solid improvement on stools. Holding the fifth star until I see the coat changes everyone mentions.'],
    [5,'Eleanor L.','04/27/2026','Daycare noticed','The daycare staff asked why she\'s suddenly so comfortable after lunch. This chew is why.'],
    [5,'Skylar M.','04/26/2026','Doxie mom approved','My mini dachshund has the diva attitude AND the sensitive gut. This handles both. Well, the gut at least.'],
    [5,'Bella N.','04/25/2026','Worth every penny','Cheaper than the vet visits we were doing twice a year for tummy issues. Do the math.'],
    [5,'Maya G.','04/24/2026','Travel tin is genius','The little treat tin lives in my purse. Routine never breaks, even on weekends away.'],
    [5,'Willow D.','04/23/2026','From skeptic vet tech','I work at a clinic. The strain transparency and honest timeline marketing won me over. Results matched.'],
    [5,'Naomi F.','04/22/2026','Happy gut, happy diva','Less bloat, more zoomies. She\'s 9 but playing like she\'s 3 again.'],
    [5,'Ruby J.','04/21/2026','The one that worked','Fourth probiotic we tried. First one she eats AND that works. We\'re done searching.']
  ];

  var FIRST = 7;
  var MORE = 5;
  var shown = 0;

  function starStr(n) {
    return '\u2605\u2605\u2605\u2605\u2605'.slice(0, n) + '\u2606\u2606\u2606\u2606\u2606'.slice(0, 5 - n);
  }

  function render(count) {
    var end = Math.min(shown + count, REVIEWS.length);
    for (var i = shown; i < end; i++) {
      var r = REVIEWS[i];
      var card = document.createElement('div');
      card.className = 'rw-card';
      card.innerHTML =
        '<div class="rw-head">' +
          '<div class="rw-avatar">' + r[1].charAt(0) + '</div>' +
          '<div class="rw-who">' +
            '<div><span class="rw-name">' + r[1] + '</span><span class="rw-verified">Verified Buyer</span></div>' +
            '<div class="rw-card-stars">' + starStr(r[0]) + '</div>' +
          '</div>' +
          '<span class="rw-date">' + r[2] + '</span>' +
        '</div>' +
        '<div class="rw-title">' + r[3] + '</div>' +
        '<p class="rw-body">' + r[4] + '</p>';
      list.appendChild(card);
    }
    shown = end;
    shownEl.textContent = shown;
    if (shown >= REVIEWS.length) moreBtn.classList.add('done');
  }

  render(FIRST);
  moreBtn.addEventListener('click', function () { render(MORE); });
})();

// ===== Shared 1s ticker — one interval drives every countdown above =====
(function () {
  var fns = window.ddEverySecond;
  if (fns && fns.length) {
    setInterval(function () {
      for (var i = 0; i < fns.length; i++) fns[i]();
    }, 1000);
  }
})();
